var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isEnabled)?_c('div',{attrs:{"id":"language-selector"}},_vm._l((_vm.languages),function(lang){return _c('div',{class:{ active: lang.locale === _vm.selectedLanguage },on:{"click":function($event){_vm.changeLanguage(lang.locale)}}},[_vm._v("\n    "+_vm._s(lang.label)+"\n  ")])}),0):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e572a450","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguageSelector.vue
// module id = null
// module chunks = 